/*    
<summary>
   This functional common component provides us custom input checkbox & has error handler that shows validation error.
   Developer:Aashish Singh, Created Date:08-Mar-2023
</summary> 
<returns>Returns JSX</returns>
*/
import React from "react";
import { injectIntl } from "react-intl";
import FormikFormErrorHandler from "./FormikFormErrorHandler";
import { useField } from "formik";

interface IProps {
  children: React.ReactNode;
  className: string;
  "data-testid"?: string;
  intl: any; //IntlConfig;
  name: string;
  onBlur: () => void;
  onChange: () => void;
  placeholder: string;
  type: string;
  value: string;
  disabled: boolean;
  readOnly: boolean;
  spaceAllowed: boolean;
  getChangeValue?: (e: any) => void;
  onUncheckClear?: () => void;
  onCheckSetAmount?: () => void;
}

const FormikFormCheckBox = (props: IProps) => {
  const [field, meta, helpers] = useField(props);
  const errorClass = `${meta.error && meta.touched ? "error" : ""}`;
  const _placeholder = props.placeholder
    ? props.intl.formatMessage({ id: props.placeholder })
    : props.placeholder;

  return (
    <>
      <input
        {...field}
        {...props}
        id={props.name}
        placeholder={_placeholder}
        className={props.className + " " + errorClass}
        disabled={props.disabled}
        type={props.type}
        readOnly={props.readOnly}
        onChange={(event) => {
          const checked = event.target.checked;
          if (props.getChangeValue) {
            props.getChangeValue(event?.target?.checked);
          }
          helpers.setValue(event.target.checked);
          if (!checked && props.onUncheckClear) {
            props.onUncheckClear();
          }
          // If the checkbox is checked and onCheckSetAmount is provided, call it
          if (checked && props.onCheckSetAmount) {
            props.onCheckSetAmount();
          }
        }}
      />
      <FormikFormErrorHandler intl={props.intl} meta={meta} />
    </>
  );
};

export default injectIntl(FormikFormCheckBox);
